<template>
  <div>
    <header-applis index-progression-courante="1" titre="Connaître votre projet" sous-titre="Le projet que je poursuis, c’est... ?"/>
    <div class="wrapper__content">
      <div v-for="(valeur, index) in valeursPossibles" :key="index" class="checkbox-wrapper">
        <input type="checkbox" :id="'choix_' + index" :value="valeur" v-model="objectifsDuProjet">
        <label :for="'choix_' + index">{{ valeur }}</label>
      </div>
    </div>
    <footer-applis ecran-precedent="accueil" :ecran-suivant="ecranSuivant" labelSuivant="Je passe à la suite"/>
  </div>
</template>

<script>
import FooterApplis from '../components/FooterApplis';
import HeaderApplis from '../components/HeaderApplis';

export default {
  name: 'recueilinfos',
  components: {
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      objectifsDuProjet: [],
      valeursPossibles: [
        'Actualiser mes compétences professionnelles',
        'Evoluer professionnellement, obtenir une promotion',
        'Me reconvertir, réorienter ma carrière',
        'Etre plus compétitif sur le marché de l’emploi',
        'Répondre aux demandes de mon employeur, aux exigences et obligations de l’entreprise',
        'Valider mes acquis professionnels, obtenir un diplôme',
        'M’enrichir, prendre plaisir à me former',
        'Développer des contacts, mon réseau'
      ],
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    },
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant() {
      if (!this.objectifsDuProjet || this.objectifsDuProjet.length === 0) {
        return '';
      }
      this.$store.commit('setObjectifsDuProjet', this.objectifsDuProjet);
      return 'choixprojet';
    }
  },
  created() {
    this.objectifsDuProjet = this.informationsParcours.objectifsDuProjet;
  }
}
</script>
